import React from "react";
import { View, StyleSheet } from "react-native";
import { CardList } from "../../../../components/molecules";

const VenueList = (props) => {
  const { items, isMobileVersion, category } = props;
  return (
    <View style={[styles.container, props.style]}>
      <CardList
        horizontal={false}
        items={items}
        showYear={false}
        isLoading={false}
        category={category}
        showInView={false}
        isMobileVersion={isMobileVersion}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignSelf: "stretch",
    marginHorizontal: 16,
  },
});

export default VenueList;
